import { Component, OnInit } from '@angular/core';
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {PedidosService} from "../../services/pedidos.service";
import {ModalKendo} from "../../lib/ModalKendo";
import {DialogService} from "@progress/kendo-angular-dialog";
import {PayloadJsonViewComponent} from "../../pedidos/tela-pedidos-erros-importar/payload-json-view/payload-json-view.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";

@Component({
  selector: 'app-modal-opendelivery-events',
  templateUrl: './modal-opendelivery-events.component.html',
  styleUrls: ['./modal-opendelivery-events.component.scss']
})
export class ModalOpendeliveryEventsComponent extends ModalKendo implements OnInit {
  pedido: any = {};
  modoGrupoLojas = false;
  eventos = [];
  carregando = true;
  notificacoes = false;
  erro = '';
  constructor( private  grupolojasService: GrupolojasService,
              private  pedidosService: PedidosService,
              private dialogService: DialogService) {
    super()
  }

  ngOnInit(): void {
    const service = this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;
    const requisicao = this.notificacoes ? service.listeNotificacoesPedidoOpenDelivery(this.pedido) : this.modoGrupoLojas
      ? this.grupolojasService.listeEventosPedido(this.pedido)
      : this.pedidosService.listeEventosPedido(this.pedido.guid);

    requisicao.then((eventos) => {
      this.carregando = false;
      this.eventos = eventos;
    }).catch((erro) => {
      this.carregando = false;
      this.erro = erro && (erro.message || erro) || 'Não foi possível carregar os eventos.';
    })
  }

  verDados(item: any) {
    const windowRef = this.dialogService.open({
      title: null, content: PayloadJsonViewComponent, minWidth: 250,
      width: window.innerWidth > 1000 ? 1000 : window.innerWidth,
      maxHeight: window.innerHeight - 100, cssClass: 'bsModal'
    });
    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    Object.assign(windowRef.content.instance, {
      payload: item.dados, titulo: `Notificação ${item.eventType}`, emTabela: true
    });
  }


}
